import React from 'react';
import { Grid, Fab, Dialog, Button, Divider, Avatar, Select, OutlinedInput, MenuItem, FormControl, InputLabel, FilledInput, TextField, DialogContent, Chip } from '@material-ui/core';
import Calendar from 'react-calendar';
import ro from 'date-fns/locale/ro';
import es from 'date-fns/locale/es'
// import en from 'date-fns/locale/en'
import Menu from '../../commons/Menu'
import PropTypes from 'prop-types'
import SubTaskuriList from '../SubTaskuriList'
import Ws from '../../providers/Ws';
import Utils from '../../providers/Utils';
import BugetEtapaTask from './BugetEtapaTask';
import LocalStorage from '../../providers/LocalStorage';
import BugetEtapaTaskB from '../../commons/BugetEtapaTaskB'
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';

import "react-datepicker/dist/react-datepicker.css";
import CustomUserMenu from '../CustomUserMenu';
import SpecificComponent from '../SpecificComponent';

registerLocale('ro', ro)

export default class InsertUpdateTask extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            strDataStart: this.props.dictionary.proiecte.etapeProiect.selectDate,
            strDataFinish: this.props.dictionary.proiecte.etapeProiect.selectDate,
            dtDataStart: new Date(),
            dtDataFinish: new Date(),
            fullScreen: false,
            isOpenBuget: false,
            listBuget: [],
            totalCost: 0,
            showCheltuieli: false,
            showCostNou: false,
            costInsert: { nume: '', valoare: '0' },
            showCostNouTotal: false,
            showCheltuieliTipuri: false,
            cheltuialaSelectata: { id: null, nume: '', document_token: null, document_nume: null, document_id: null, tip: 'cost_direct' },
            subCosturi: [],
            totalBuget: 0,
            showBuget: false,
            showBugetNou: false,
            showBugetNouTotal: false,
            showBugetTipuri: false,
            tipBuget: '',
            tipBugetVal: this.dictionary.proiecte.tipIntroducere,
            valoriTva: new Utils().valoriTva,
            bugetTva: '19',
            denumireBuget: '',
            valoareBuget: '',
            nrOre: '',
            totalBTVA: 0,
            totalCTVA: 0,
            descrieri: [],
            tipuriIntroducere: [{ id: 'individuala', nume: this.dictionary.proiecte.cheltuialaIndividuala }, { id: 'defalcata', nume: this.dictionary.proiecte.cheltuialaDefalcata }],
            tipuriIntroducereB: [{ id: 'individuala', nume: this.dictionary.proiecte.bugetIndividual }, { id: 'defalcata', nume: this.dictionary.proiecte.bugetDefalcat }],
            tipIntroducere: 'individuala',
            isOpenBugetB: false,
            docSubcosturi: [],
            bugetSelectat: { id: null, nume: '', document_token: null, document_nume: null, document_id: null, tip: 'cost_direct' },
            openList: false

        }
    }

    componentDidMount() {

        this.getWindowDimentions()
    }

    ws = new Ws()

    getWindowDimentions = () => {
        let windowWidth = window.innerWidth


        this.setState({
            fullScreen: windowWidth <= 800 ? true : false
        })

    }






    filterSubTaskuri = () => {

        let filterSubTaskuri = this.props.listSubTaskuri.filter(t => t.id_task_parent === this.props.objInfoTask.id)

        // console.log('listTaskuri :', this.props.listTaskuri);
        //         console.log('filterSubTaskuri :', filterSubTaskuri);

        return (
            <SubTaskuriList
                objInfoTask={this.props.objInfoTask}
                listSubTaskuri={filterSubTaskuri}
                dictionary={this.props.dictionary}
                dataStart={this.state.strDataStart}
                dataFinish={this.state.strDataFinish}
                dtDataStart={this.props.dtDataStart}
                dtDataFinish={this.props.dtDataFinish}
                isUserView={this.props.userView}
                getData={this.props.getData}
            />
        )
    }


    getLitereAvatar = (tx) => {

        // console.log('tx :', tx);

        if (tx !== null) {

            return tx.substring(0, 2)
        }
    }


    termenLimita = () => {
        let dataAzi = new Date()
        let dataLimita = this.props.dtDataFinish

        let dataFinalizat = new Utils().ParseDataFromSql(this.props.objInfoTask.cand_finalizat)



        dataFinalizat = new Date(dataFinalizat)
        console.log('dataLimita :>> ', dataLimita);

        if (dataFinalizat.getTime() <= dataLimita) {
            return true
        } else {
            if (dataAzi.getTime() > dataLimita.getTime()) {
                return true
            } else {
                return false
            }
        }


        if (dataAzi.getTime() > dataLimita.getTime()) {
            return true
        } else {
            return false
        }
    }

    openBugetEtapa = async (tip = null ) => {

        let ws = new Ws()
        let u = new Utils()

        let _getBugete = ws.customSelect('select * from costuri_taskuri where id_task = @p1 and isnull(sters,0) != 1', {
            p1: this.props.objInfoTask.id
        })


        let _getBugetC = ws.customSelect('select * from bugete_taskuri where id_task = @p1 and isnull(sters,0) != 1', {
            p1: this.props.objInfoTask.id
        })

        let _getDescrieri = ws.customSelect('select * from taskuri_descrieri where id_task = @p1 and isnull(sters,0) != 1 ', {
            p1: this.props.objInfoTask.id
        })


        let [getBugete, getBugeteC, getDescrieri] = await Promise.all([_getBugete, _getBugetC, _getDescrieri])

        console.log('getBugete :>> ', getBugete);
        console.log('getBugeteC :>> ', getBugeteC);
        console.log('getDescrieri :>> ', getDescrieri);
        if (getBugete.Succes && getBugeteC.Succes && getDescrieri.Succes) {

            let costuri = [...getBugete.Content]

            let bugete = [...getBugeteC.Content]



            let sum = 0

            let sumB = 0

            let sumBTva = 0

            let sumCTva = 0

            for (let i = 0, n = costuri.length; i < n; i++) {
                costuri[i].data_costului = u.ParseDataFromSql(costuri[i].data_costului)
                sum += costuri[i].valoare
                costuri[i]['edit'] = false

                let idx = this.props.listDocumente.findIndex(d => d.id_cost === costuri[i].id)

                if (idx !== -1) {
                    costuri[i]['document_token'] = this.props.listDocumente[idx].token
                    costuri[i]['document_id'] = this.props.listDocumente[idx].id
                    costuri[i]['document_nume'] = this.props.listDocumente[idx].nume
                }

            }


            for (let i = 0, n = bugete.length; i < n; i++) {
                bugete[i].data_costului = u.ParseDataFromSql(bugete[i].data_costului)
                bugete[i]['edit'] = false

                if (bugete[i].tip === 'cheltuiala_cu_personal') {
                    sumB += Number(bugete[i].valoare) * Number(bugete[i].nr_ore)
                    sumBTva += (Number(bugete[i].valoare) * Number(bugete[i].nr_ore)) * Number(bugete[i].tva || 0) / 100

                } else {
                    sumB += Number(bugete[i].valoare) + (Number(bugete[i].valoare) * (Number(bugete[i].tva) / 100))
                    sumBTva += Number(bugete[i].valoare) * Number(bugete[i].tva || 0) / 100
                }

            }

            console.log('listBuget :>> ', costuri);
            // console.log('dtDataFinish :>> ', this.props.dtDataFinish);

            let idxBuget = bugete.findIndex(c => c.id === this.state.bugetSelectat.id)
            let buget = { id: null, nume: '', document_token: null, document_nume: null, document_id: null, tip: 'cost_direct' }
            console.log('idxBuget :>> ', idxBuget);
            if (idxBuget !== -1) {

                buget = bugete[idxBuget]
            }

            console.log('buget :>> ', buget);


            let idx = costuri.findIndex(c => c.id === this.state.cheltuialaSelectata.id)
            let cheltuiala = { id: null, nume: '', document_token: null, document_nume: null, document_id: null, tip: 'cost_direct' }

            console.log('idx :>> ', idx);
            if (idx !== -1) {

                cheltuiala = costuri[idx]

                console.log('cheltuiala :>> ', cheltuiala);


            }

            if(this.state.bugetSelectat.id !== null){
                this.setState({
                    totalCost: +(Math.round(sum + "e+3") + "e-3"),
                    totalBuget: +(Math.round(sumB + "e+3") + "e-3"),
                    totalBTVA: +(Math.round(sumBTva + "e+3") + "e-3"),
                    totalCTVA: +(Math.round(sumCTva + "e+3") + "e-3"),
                    cheltuialaSelectata: cheltuiala,
                    // isOpenBuget: true,
                    descrieri: getDescrieri.Content,
                    listBuget: costuri,
                    listBugetC: bugete,
                    showCheltuieliTipuri: false,
                    showCostNouTotal: false,
                    showCheltuieli: false,
                    showCostNou: false,
                    isOpenBugetB: true,
                    isOpenBuget: false
                })

            }else if(this.state.cheltuialaSelectata.id !== null){
                this.setState({
                    totalCost: +(Math.round(sum + "e+3") + "e-3"),
                    totalBuget: +(Math.round(sumB + "e+3") + "e-3"),
                    totalBTVA: +(Math.round(sumBTva + "e+3") + "e-3"),
                    totalCTVA: +(Math.round(sumCTva + "e+3") + "e-3"),
                    bugetSelectat: buget,
                    // isOpenBuget: true,
                    descrieri: getDescrieri.Content,
                    listBuget: costuri,
                    listBugetC: bugete,
                    showCheltuieliTipuri: false,
                    showCostNouTotal: false,
                    showCheltuieli: false,
                    showCostNou: false,
                    isOpenBugetB: false,
                    isOpenBuget: true
                })
            }else{
                this.setState({
                    totalCost: +(Math.round(sum + "e+3") + "e-3"),
                    totalBuget: +(Math.round(sumB + "e+3") + "e-3"),
                    totalBTVA: +(Math.round(sumBTva + "e+3") + "e-3"),
                    totalCTVA: +(Math.round(sumCTva + "e+3") + "e-3"),
                    cheltuialaSelectata: cheltuiala,
                    bugetSelectat: buget,
                    // isOpenBuget: true,
                    descrieri: getDescrieri.Content,
                    listBuget: costuri,
                    listBugetC: bugete,
                    showCheltuieliTipuri: false,
                    showCostNouTotal: false,
                    showCheltuieli: false,
                    showCostNou: false,
                    isOpenBugetB: false,
                    isOpenBuget: false
                })
            }



           
        }

    }


    numeConstChange = (e, ev) => {
        let cloneCosturi = [...this.state.listBuget]

        let idx = cloneCosturi.findIndex(c => c.id === e.id)

        cloneCosturi[idx].nume = ev.target.value

        this.setState({ listBuget: cloneCosturi })
    }

    numeBugetChange = (e, ev) => {
        let cloneCosturi = [...this.state.listBugetC]

        let idx = cloneCosturi.findIndex(c => c.id === e.id)

        cloneCosturi[idx].nume = ev.target.value

        this.setState({ listBugetC: cloneCosturi })
    }

    valoareCostChange = (e, ev) => {

        let cloneCosturi = [...this.state.listBuget]

        let idx = cloneCosturi.findIndex(c => c.id === e.id)

        cloneCosturi[idx].valoare = ev.target.value

        this.setState({ listBuget: cloneCosturi })

    }

    valoareBugetchange = (e, ev) => {

        let cloneCosturi = [...this.state.listBugetC]

        let idx = cloneCosturi.findIndex(c => c.id === e.id)

        cloneCosturi[idx].valoare = ev.target.value

        this.setState({ listBugetC: cloneCosturi })

    }

    dataCostChange = (e, ev) => {
        let cloneCosturi = [...this.state.listBuget]

        let idx = cloneCosturi.findIndex(c => c.id === e.id)

        cloneCosturi[idx].data_costului = ev.target.value

        this.setState({ listBuget: cloneCosturi })
    }

    dataBugetChange = (e, ev) => {
        let cloneCosturi = [...this.state.listBugetC]

        let idx = cloneCosturi.findIndex(c => c.id === e.id)

        cloneCosturi[idx].data_costului = ev.target.value

        this.setState({ listBugetC: cloneCosturi })
    }

    updateNume = async (e) => {
        // console.log('v :', e);

        let ws = new Ws()

        let obj = {
            nume: e.nume
        }


        // console.log('obj :', obj);

        let updateN = await ws.update('costuri_taskuri', obj, { id: e.id })


    }


    updateNumeBuget = async (e) => {
        // console.log('v :', e);

        let ws = new Ws()

        let obj = {
            nume: e.nume
        }


        // console.log('obj :', obj);

        let updateN = await ws.update('bugete_taskuri', obj, { id: e.id })


    }

    updateValoareCost = async (v) => {
        // console.log('v :', v);

        let ws = new Ws()

        let obj = {
            valoare: v.valoare,

        }


        let updateBugete = await ws.update('costuri_taskuri', obj, { id: v.id })


    }

    updateValoareBuget = async (v) => {
        // console.log('v :', v);

        let ws = new Ws()

        let obj = {
            valoare: v.valoare,

        }


        let updateBugete = await ws.update('bugete_taskuri', obj, { id: v.id })


    }

    updateValoareTotalaCost = async (v) => {
        let ws = new Ws()

        let obj = {
            valoare: v,

        }

        console.log('obj.valoare :>> ', obj.valoare);

        let updateBugete = await ws.update('costuri_taskuri', obj, { id: this.state.cheltuialaSelectata.id })

        console.log('updateBugete :>> ', updateBugete);

        if (updateBugete.Succes) {
            this.setState({

                showCheltuieliTipuri: false,
                showCostNouTotal: false,
                showCheltuieli: false,
                showCostNou: false,
                isOpenBuget: false,
                cheltuialaSelectata: { id: null, nume: '', document_token: null, document_nume: null, document_id: null },
            }, () => {
                this.openBugetEtapa()
            })
        }
    }

    updateValoareTotalaBuget = async (v) => {
        let ws = new Ws()

        let obj = {
            valoare: v,

        }

        console.log('obj.valoare :>> ', obj.valoare);

        let updateBugete = await ws.update('bugete_taskuri', obj, { id: this.state.bugetSelectat.id })

        console.warn('updateBugete :>> ', updateBugete);

        if (updateBugete.Succes) {
            this.setState({

                showCheltuieliTipuri: false,
                showCostNouTotal: false,
                showCheltuieli: false,
                showCostNou: false,
                isOpenBugetB: false,
                bugetSelectat: { id: null, nume: '', document_token: null, document_nume: null, document_id: null },
            }, () => {
                this.openBugetEtapa()
            })
        }
    }

    updateDataCost = async (d) => {


        let ws = new Ws()

        let obj = {
            data_costului: d.data_costului,

        }


        let updateBugete = await ws.update('costuri_taskuri', obj, { id: d.id })

    }

    updateDataBuget = async (d) => {


        let ws = new Ws()

        let obj = {
            data_costului: d.data_costului,

        }


        let updateBugete = await ws.update('bugete_taskuri', obj, { id: d.id })

    }



    changeBuget = (ev, c) => {

        let val = ev.target.value
        let n = ev.target.name


        let cloneCosturi = [...this.state.listBugetC]

        let idx = cloneCosturi.findIndex(cc => cc.id === c.id)

        if (idx !== -1) {

            cloneCosturi[idx][n] = val

            this.setState({ listBugetC: cloneCosturi })
        }
    }


    editBuget = (c) => {
        let cloneCosturi = [...this.state.listBugetC]

        let idx = cloneCosturi.findIndex(cc => cc.id === c.id)




        if (idx !== -1) {
            cloneCosturi[idx].edit = true

            this.setState({ listBugetC: cloneCosturi })
        }
    }

    updateBuget = async (c) => {
        // console.log('c :>> ', c);


        let objToUpdate = {
            nume: c.nume,
            valoare: Number(c.valoare),
            tva: Number(c.tva),
            nr_ore: Number(c.nr_ore),

        }

        // console.log('objToUpdate :>> ', objToUpdate);


        let update = await this.ws.update('bugete_taskuri', objToUpdate, { id: c.id })

        if (update.Succes) {
            let cloneCosturi = [...this.state.listBugetC]

            let idx = cloneCosturi.findIndex(cc => cc.id === c.id)

            if (idx !== -1) {
                cloneCosturi[idx]['edit'] = false

                this.setState({ listBugetC: cloneCosturi }, () => {
                    this.openBugetEtapa()
                })
            }
        }

    }


    deleteBuget = async (c) => {
        let cloneCosturi = [...this.state.listBugetC]

        let deleteCost = await this.ws.update('bugete_taskuri', { sters: 1 }, { id: c.id })

        if (deleteCost.Succes) {

            let idx = cloneCosturi.findIndex(cc => cc.id === c.id)

            if (idx !== -1) {
                cloneCosturi.splice(idx, 1)

                this.setState({ listBugetC: cloneCosturi }, () => {
                    this.openBugetEtapa()
                })
            }
        }
    }





    changeCost = (ev, c) => {

        let val = ev.target.value
        let n = ev.target.name


        let cloneCosturi = [...this.state.listBuget]

        let idx = cloneCosturi.findIndex(cc => cc.id === c.id)

        if (idx !== -1) {

            cloneCosturi[idx][n] = val

            this.setState({ listBuget: cloneCosturi })
        }


    }


    editCost = async (c) => {

        let cloneCosturi = [...this.state.listBuget]

        let idx = cloneCosturi.findIndex(cc => cc.id === c.id)




        if (idx !== -1) {
            cloneCosturi[idx].edit = true

            this.setState({ listBuget: cloneCosturi })
        }

    }

    changeCostInsert = (ev) => {

        let val = ev.target.value
        let n = ev.target.name

        let obj = { ...this.state.costInsert }

        obj[n] = val

        this.setState({ costInsert: obj })

    }


    insertCost = async () => {

        let costToInsert = { ...this.state.costInsert }

        costToInsert['data_costului'] = new Utils().updateSqlNow()
        costToInsert['id_task'] = this.props.objInfoTask.id



        // console.log('costToInsert :>> ', costToInsert);


        let insert = await this.ws.insert('costuri_taskuri', costToInsert)

        // console.log('insert :>> ', insert);

        if (insert.Succes) {
            costToInsert['id'] = insert.Content[0].id

            let costuri = [...this.state.listBuget]

            costuri.push(costToInsert)

            this.setState({
                listBuget: costuri,
                showCheltuieli: false,
                showCostNou: false,
                showCostNouTotal: false,
                costInsert: { nume: '', valoare: '0' },

            }, () => {
                this.openBugetEtapa()
            })
        }
    }

    updateCost = async (c) => {
        console.log('c :>> ', c);

        let ls = new LocalStorage().GetUserData()
        let u = new Utils()

        console.log('ls :>> ', ls);


        let objToUpdate = {
            nume: c.nume,
            valoare: Number(c.valoare)
        }

        // console.log('objToUpdate :>> ', objToUpdate);

        let getOldCost = await this.ws.customSelect(`select * from costuri_taskuri where id = @p1`, {
            p1: c.id
        })
        // console.log('getOldCost :>> ', getOldCost);

        if (getOldCost.Succes) {
            let costVechi = getOldCost.Content.length > 0 ? getOldCost.Content[0] : {}

            console.log('costVechi :>> ', costVechi);

            let costLog = {
                id_cost: c.id,
                id_cine: ls['InfoUser']['IdUser'],
                nume_cine: ls['Nume'],
                cand: u.updateSqlNow(),
                note: ''
            }


            if (costVechi['nume'] !== c.nume) {
                costLog['note'] += ` a modificat Numele acestei cheltuieli din ${costVechi['nume']} in ${c.nume} `
            }
            if (costVechi['valoare'] !== c.valoare) {

                if (costLog['note'].length > 0) {
                    costLog['note'] += `si Valoarea acestei cheltuieli din ${costVechi['valoare']} in ${c.valoare} `
                } else {
                    costLog['note'] += ` a modificat Valoarea acestei cheltuieli din ${costVechi['valoare']} in ${c.valoare} `
                }

            }



            if (costLog['note'].length > 0) {
                let insertLog = await this.ws.insert('costuri_taskuri_log_modificari', costLog)

                if (insertLog.Succes) {
                    let update = await this.ws.update('costuri_taskuri', objToUpdate, { id: c.id })



                    if (update.Succes) {
                        let cloneCosturi = [...this.state.listBuget]

                        let idx = cloneCosturi.findIndex(cc => cc.id === c.id)


                        if (idx !== -1) {
                            cloneCosturi[idx]['edit'] = false

                            this.setState({ listBuget: cloneCosturi }, async () => {




                            })
                        }


                    }
                    console.log('log inserat cu succes :>> ');
                }

            } else {
                let update = await this.ws.update('costuri_taskuri', objToUpdate, { id: c.id })



                if (update.Succes) {
                    let cloneCosturi = [...this.state.listBuget]

                    let idx = cloneCosturi.findIndex(cc => cc.id === c.id)


                    if (idx !== -1) {
                        cloneCosturi[idx]['edit'] = false

                        this.setState({ listBuget: cloneCosturi }, async () => {




                        })
                    }


                }

            }


        }




    }


    deleteCost = async (c) => {


        let cloneCosturi = [...this.state.listBuget]

        let deleteCost = await this.ws.update('costuri_taskuri', { sters: 1 }, { id: c.id })

        if (deleteCost.Succes) {

            let idx = cloneCosturi.findIndex(cc => cc.id === c.id)

            if (idx !== -1) {
                cloneCosturi.splice(idx, 1)

                this.setState({ listBuget: cloneCosturi }, () => {
                    this.openBugetEtapa()
                })
            }
        }
    }


    addFileCost = (id) => {
        let pi = document.getElementById(id)

        pi.click()
    }

    uploadCostDoc = async (id, idTask, c) => {
        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);

        reader.onload = async () => {
            let fileContent = reader.result;
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);

            //

            console.log('c :>> ', c);
            let uploadImage = await ws.uploadimage('Upload/DocTask', saveFile, idTask, this.props.proiectInfo[0].id, 'cost', c.id, -1);

            console.log('uploadImage COST :', uploadImage);
            if (uploadImage.Succes) {
                this.props.getTaskData()
            }


        }
    }


    uploadBugetDoc = async (id, idTask, c) => {
        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);

        reader.onload = async () => {
            let fileContent = reader.result;
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);

            //
            let uploadImage = await ws.uploadimage('Upload/DocTask', saveFile, idTask, this.props.proiectInfo[0].id, 'buget', -1, c.id);

            console.log('uploadImage COST :', uploadImage);
            if (uploadImage.Succes) {
                this.props.getTaskData()
            }


        }
    }


    selectTaskFile = (id) => {
        //  console.log('Incepe poza');
        let pi = document.getElementById(id);

        pi.click()
    }

    uploadTaskDoc = async (id, idTask) => {
        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);

        reader.onload = async () => {
            let fileContent = reader.result;
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);

            // console.log('idTask :>> ', idTask);
            // console.log('this.props.proiectInfo :>> ', this.props.proiectInfo);

            let uploadImage = await ws.uploadimage('Upload/DocTask', saveFile, idTask, this.props.proiectInfo[0].id);

            console.log('uploadImage :', uploadImage);
            if (uploadImage.Succes) {
                this.props.getTaskData()
            }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);

        }
    }

    goToFile = (f) => {
        let adresaFisa = new Ws().adresaMedia + `/Taskuri/Docs/${f.token}`

        window.open(adresaFisa)
    }

    goToFileCost = (f) => {
        let adresaFisa = new Ws().adresaMedia + `/Taskuri/Docs/${f.document_token}`

        window.open(adresaFisa)
    }


    deleteDoc = async (d) => {

        // console.log('d :>> ', d);

        let delDoc = await this.ws.update('taskuri_documente', { sters: 1 }, { id: d.id })

        if (delDoc.Succes) {
            this.props.getTaskData()
        }
    }

    changeNumeCheltuiala = (ev) => {

        let cheltuialaSelectata = { ...this.state.cheltuialaSelectata }

        cheltuialaSelectata['nume'] = ev.target.value

        this.setState({ cheltuialaSelectata: cheltuialaSelectata })
    }

    changeNumeBuget = (ev) => {
        let bugetSelectat = { ...this.state.bugetSelectat }


        bugetSelectat['nume'] = ev.target.value

        this.setState({ bugetSelectat: bugetSelectat })
    }


    changeTipBuget = (ev) => {
        let bugetSelectat = { ...this.state.bugetSelectat }

        bugetSelectat['tip'] = ev.target.value

        this.setState({ bugetSelectat: bugetSelectat })
    }

    changeTip = (ev) => {
        let cheltuialaSelectata = { ...this.state.cheltuialaSelectata }

        cheltuialaSelectata['tip'] = ev.target.value

        this.setState({ cheltuialaSelectata: cheltuialaSelectata })
    }

    selectCost = async (c, t = null) => {


        let _subCosturi = await this.ws.customSelect(`select c.*, b.id_buget from costuri_taskuri_rows c left join bugete_legatura_cheltuieli b
            on c.id = b.id_cheltuiala
        where c.id_cost  = @p1 and isnull(c.sters,0) != 1 and isnull(b.sters, 0 ) != 1`, {
            p1: c.id
        })

        let _docSubcosturi = this.ws.customSelect(`select * from costuri_taskuri_rows_documente where id_row_cost in (select id from costuri_taskuri_rows where id_cost = @p1 and isnull(sters,0) != 1) and isnull(sters,0) != 1`, {
            p1: c.id
        })





        let [subCosturi, docSubcosturi] = await Promise.all([_subCosturi, _docSubcosturi])



        if (subCosturi.Succes && docSubcosturi.Succes) {

            console.warn('subcosturi :>> ', subCosturi);

            console.log('docSubcosturi :>> ', docSubcosturi);

            if (this.state.isOpenBuget) {
                this.setState({
                    cheltuialaSelectata: c,
                    subCosturi: subCosturi.Content,
                    docSubcosturi: docSubcosturi.Content,
                    isOpenBuget: true
                })
            } else {
                this.setState({
                    cheltuialaSelectata: c,
                    subCosturi: subCosturi.Content,
                    docSubcosturi: docSubcosturi.Content,
                    tipIntroducere: subCosturi.Content.length > 1 ? 'defalcata' : 'individuala',
                    isOpenBuget: true
                })
            }



        }


    }


    selectBuget = async (b, t = null) => {


        console.log('b :>> ', b);


        let _subCosturi = this.ws.customSelect(`select * from bugete_taskuri_rows where id_cost = @p1 and isnull(sters,0) != 1`, {
            p1: b.id
        })

        let _docSubcosturi = this.ws.customSelect(`select * from bugete_taskuri_rows_documente where id_row_cost in (select id from bugete_taskuri_rows where id_cost = @p1 and isnull(sters,0) != 1)  and isnull(sters,0) != 1`, {
            p1: b.id
        })


        let [subCosturi, docSubcosturi] = await Promise.all([_subCosturi, _docSubcosturi])


        console.log('docSubcosturi :>> ', docSubcosturi);

        console.log('c :>> ', b);

        console.log('subcosturi :>> ', subCosturi);

        if (subCosturi.Succes && docSubcosturi.Succes) {


            if (this.state.isOpenBugetB) {
                this.setState({
                    bugetSelectat: b,
                    subCosturi: subCosturi.Content,
                    docSubcosturi: docSubcosturi.Content,
                    isOpenBugetB: true
                })
            } else {
                this.setState({
                    bugetSelectat: b,
                    subCosturi: subCosturi.Content,
                    docSubcosturi: docSubcosturi.Content,
                    tipIntroducere: subCosturi.Content.length > 1 ? 'defalcata' : 'individuala',
                    isOpenBugetB: true
                })
            }


        }
    }

    openDetaliat = () => {


        this.setState({
            showCheltuieliTipuri: false,
            cheltuialaSelectata: { id: null, nume: '', document_token: null, document_nume: null, document_id: null },
            showCostNouTotal: false,
            showCheltuieli: false,
            showCostNou: false,
            isOpenBuget: true
        }, () => {
            this.insertOrUpdateCost()
        })
    }


    openBugetDetaliat = () => {
        this.setState({
            bugetSelectat: { id: null, nume: '', document_token: null, document_nume: null, document_id: null },

            isOpenBugetB: true
        }, () => {
            this.insertUpdateBuget()
        })
    }

    changeCostObj = (ev, c) => {
        console.log('c :>> ', c);
        console.log('ev.target.value :>> ', ev.target.name);

        let val = ev.target.value
        let n = ev.target.name

        console.log('val :>> ', val);

        let listSubCosturi = [...this.state.subCosturi]

        let idx = listSubCosturi.findIndex(sc => sc.id === c.id)

        if (idx !== -1) {
            listSubCosturi[idx][n] = val
            this.setState({ subCosturi: listSubCosturi })
        }
    }



    insertOrUpdateCost = async () => {

        if (this.state.cheltuialaSelectata.id) {
            let updateNumeCheltuiala = await this.ws.update('costuri_taskuri', { nume: this.state.cheltuialaSelectata.nume || '', tip: this.state.cheltuialaSelectata.tip || 'cost_direct' }, { id: this.state.cheltuialaSelectata.id })

            console.log('updateNumeCheltuiala :>> ', updateNumeCheltuiala);
            if (updateNumeCheltuiala.Succes) {
                this.selectCost(this.state.cheltuialaSelectata)
            }

        } else {

            let insertCheltuiala = await this.ws.insert('costuri_taskuri', { nume: this.state.cheltuialaSelectata.nume || '', tip: this.state.cheltuialaSelectata.tip || 'cost_direct', data_costului: new Utils().updateSqlNow(), id_task: this.props.objInfoTask.id })

            if (insertCheltuiala.Succes) {



                let cheltuialaSelectata = { ...this.state.cheltuialaSelectata }

                cheltuialaSelectata.id = insertCheltuiala.Content[0].id



                let costToAdd = { denumire: '', cantitate: 0, pret: 0, tva: 19 }

                costToAdd['id_cost'] = cheltuialaSelectata.id

                let insertCost = await this.ws.insert('costuri_taskuri_rows', costToAdd)


                console.log('costToAdd :>> ', costToAdd);
                console.log('cheltuialaSelectata :>> ', this.state.cheltuialaSelectata);

                console.log('insertCost :>> ', insertCost);

                cheltuialaSelectata['tip'] = 'cost_direct'

                if (insertCost.Succes) {

                    this.setState({ cheltuialaSelectata: cheltuialaSelectata }, () => {
                        this.selectCost(cheltuialaSelectata)
                    })
                }


            }
        }
    }

    insertUpdateBuget = async () => {

        if (this.state.bugetSelectat.id) {
            console.log('this.state.bugetSelectat :>> ', this.state.bugetSelectat);
            let updateNumeCheltuiala = await this.ws.update('bugete_taskuri', { nume: this.state.bugetSelectat.nume || '', tip: this.state.bugetSelectat.tip || 'cost_direct' }, { id: this.state.bugetSelectat.id })

            console.log('updateNumeCheltuiala :>> ', updateNumeCheltuiala);
            if (updateNumeCheltuiala.Succes) {
                this.selectBuget(this.state.bugetSelectat)
            }

        } else {

            let insertCheltuiala = await this.ws.insert('bugete_taskuri', { nume: this.state.bugetSelectat.nume || '', tip: this.state.bugetSelectat.tip || 'cost_direct', data_costului: new Utils().updateSqlNow(), id_task: this.props.objInfoTask.id })

            if (insertCheltuiala.Succes) {



                let bugetSelectat = { ...this.state.bugetSelectat }

                console.log('bugetSelectat :>> ', bugetSelectat);
                bugetSelectat.id = insertCheltuiala.Content[0].id



                let costToAdd = { denumire: '', cantitate: 0, pret: 0, tva: 19 }

                costToAdd['id_cost'] = bugetSelectat.id


                console.log('costToAdd :>> ', costToAdd);

                let insertCost = await this.ws.insert('bugete_taskuri_rows', costToAdd)


                console.log('costToAdd :>> ', costToAdd);
                console.log('bugetSelectat :>> ', this.state.bugetSelectat);

                console.log('insertCost :>> ', insertCost);

                bugetSelectat['tip'] = 'cost_direct'

                if (insertCost.Succes) {

                    this.setState({ bugetSelectat: bugetSelectat }, () => {
                        this.selectBuget(bugetSelectat)
                    })
                }


            }
        }
    }


    insertBuget = async () => {


        let ws = new Ws()

        let objToInsert = {
            cantitate: 1,
            data_costului: new Utils().updateSqlNow(),
            id_task: this.props.objInfoTask.id,
            nume: this.state.denumireBuget,
            tva: Number(this.state.bugetTva),
            valoare: Number(this.state.valoareBuget),
            nr_ore: this.state.nrOre || 0,
            tip: this.state.tipBuget

        }


        console.log('objToInsert :>> ', objToInsert);



        let insertBuget = await ws.insert('bugete_taskuri', objToInsert)

        console.log('insertBuget :>> ', insertBuget);

        if (insertBuget.Succes) {
            this.setState({
                showBuget: false,
                showBugetNou: false,
                showBugetNouTotal: false,
                showBugetTipuri: false,
                tipBuget: '',
                tipBugetVal: 'Tip de Introducere',
                valoriTva: new Utils().valoriTva,
                bugetTva: '19',
                denumireBuget: '',
                valoareBuget: '',
                nrOre: ''
            }, () => {
                this.openBugetEtapa()
            })
        }
    }


    numeAvatar = (nume) => {

        if (nume) {
            let n = nume.split(' ')

            // console.log('n :>> ', n);

            let firstLetters = ''

            if (n[0]) {

                firstLetters += n[0].substring(0, 1)

            }
            if (n[1]) {
                firstLetters += n[1].substring(0, 1)
            }

            firstLetters = firstLetters.toUpperCase()

            return firstLetters
        } else {
            return 'NA'
        }


    }





    fisierBuget = (c) => {
        console.log('c :>> ', c);
    }



    addDescriere = async () => {

        let addDescriere = await this.ws.insert('taskuri_descrieri', { id_task: this.props.objInfoTask.id, descriere: '' })

        if (addDescriere.Succes) {
            this.openBugetEtapa()
        }
    }


    deleteDescriere = async (d) => {
        console.log('d :>> ', d);
        let delDescriere = await this.ws.update('taskuri_descrieri', { sters: 1 }, { id: d.id })

        if (delDescriere.Succes) {
            this.openBugetEtapa()
        }
    }


    changeDescriere = (ev, d) => {
        console.log('ev :>> ', ev);
        console.log('d :>> ', d);

        let descrieri = [...this.state.descrieri]

        let idx = descrieri.findIndex(i => i.id === d.id)

        if (idx !== -1) {
            descrieri[idx]['descriere'] = ev.target.value

            this.setState({ descrieri: descrieri })
        }

    }

    updateDescriere = async (d) => {
        console.log('d :>> ', d);

        let updateDescriere = await this.ws.update('taskuri_descrieri', { descriere: d.descriere }, { id: d.id })

        if (updateDescriere.Succes) {
            this.openBugetEtapa()
        }

    }


    goToUser = () => {
        if (this.props.readOnly) {
            return false
        } else {
            this.props.userClick()
        }
    }


    render() {
        return (
            <div>

                <Dialog

                    disableEscapeKeyDown
                    className='pm-task-dialog '
                    style={{ overflow: 'scroll' }}
                    fullWidth={true}
                    maxWidth={'md'}
                    fullScreen={this.state.fullScreen}

                    open={this.props.open}
                    onClose={this.props.dialogClose}>

                    <Fab onClick={this.props.dialogClose}
                        className="pm-round-button-dialog"
                        style={{ boxShadow: 'none', backgroundColor: 'transparent' }}
                    >
                        <i style={{ color: 'black', fontSize: 28, fontWeight: 500 }} className='material-icons'>close</i>
                    </Fab>

                    <DialogContent>
                        <Grid container className='pm-insert-task-header'>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <div style={{ position: 'relative' }}>

                                    <input
                                        style={{ width: '90%', fontSize: 18, fontWeight: 700 }}
                                        className='add-project-input'
                                        type="text"
                                        margin="normal"
                                        id='titlu-task'
                                        type="text"
                                        disabled={this.props.readOnly}
                                        // className='hidden-input'
                                        // margin="normal"
                                        value={this.props.taskTitle}
                                        onChange={this.props.taskTitleChange}
                                        onBlur={this.props.updateTaskTitle}
                                        placeholder={this.props.dictionary.proiecte.nameTask}
                                    />
                                    <label className='inputLabelPM' htmlFor='titlu-task'>{this.props.dictionary.proiecte.name}</label>
                                </div>


                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <span style={{ fontSize: 14 }}> <span className='pm-blue-span'>{this.props.proiectInfo[0].titlu} </span>/ <span className='pm-blue-span'>{this.props.etapaInfo.denumire}</span> / <span className='pm-blue-span'>{this.props.taskTitle}</span> </span>
                            </Grid>

                            <Grid style={{ marginTop: 20 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                <span className='insert-task-labels' style={{
                                    fontSize: 15,
                                    fontWeight: 500,
                                    color: 'gray'
                                }} >{this.props.dictionary.proiecte.responsable}:





                                    <div style={{ display: 'inline-block', widht: '45%' }}>
                                        <CustomUserMenu
                                            user={this.props.objInfoTask}
                                            clearInput={() => {


                                                this.props.clearAngajat()
                                            }}
                                            openList={() => { this.setState({ openList: this.props.readOnly ? false : true }) }}
                                            closeList={() => { this.setState({ openList: false }) }}
                                            showList={this.state.openList}
                                            users={this.props.listUsers}
                                            selectUser={this.props.closeUtilizator}
                                            width={'100%'}
                                            label={this.props.dictionary.proiecte.selectUser}

                                        />
                                    </div>

                                </span>
                            </Grid>


                            <Grid style={{ marginTop: 20 }} item xs={6} sm={6} md={6} lg={6} xl={6}>


                                <div>

                                </div>


                                {/* <Grid style={{marginTop:20}} container>
                                                            <Grid style={{ marginBottom: 20 }} item xs={6} sm={6} md={6} lg={6} xl={6}> */}

                                <span onClick={this.props.showCalendarStart} className='insert-task-labels' id='data-inceput-task'><span style={{
                                    fontSize: 15,
                                    fontWeight: 500,
                                    color: 'gray'
                                }}>{this.props.dictionary.proiecte.date}:</span>

                                    <div style={{display:'inline-block', widht:'fit-content'}}>
                                        <DatePicker
                                            style={{ width: 'fit-content' }}
                                            selected={this.props.dtDataStart}
                                            onChange={this.props.dataStartChange}
                                            startDate={this.props.dtDataStart}
                                            endDate={this.props.dtDataFinish}
                                            selectsRange
                                            shouldCloseOnSelect={false}
                                            calendarClassName="calendar-left-absolute"
                                            locale="ro"
                                            disabled={this.props.readOnly}
                                            dateFormat="dd/MM/yyyy"
                                            customInput={<div className='pm-date-picker'>

                                                <span>     <i style={{

                                                    fontSize: 18,
                                                    verticalAlign: 'middle'

                                                }} className='material-icons'>today</i>


                                                    {this.props.dataStart} - {this.props.dataFinish}

                                                    {/* <i onClick={this.props.showCalendarStart} className='material-icons task-edit'>create</i> */}
                                                </span>

                                                <i className='material-icons pm-date-picker-x-icon'>clear</i>
                                            </div>}
                                            monthsShown={2}
                                        />
                                    </div>





                                </span>





                                {/* <div style={{
                                    maxWidth: 220, position: 'absolute',
                                    zIndex: 1001
                                }}>
                                    <Calendar

                                        className={this.props.hideCalendar ? 'pm-hide-calendar' : ''}
                                        locale={this.props.dictionary.date}
                                        onChange={this.props.dataStartChange}
                                        value={[this.props.dtDataStart,this.props.dtDataFinish ]}
                                        selectRange={true}
                                        
                                        showNeighboringMonth={true}
                                    />

                                </div> */}
                                {/* <div style={{
                                    maxWidth: 220,
                                    position: 'absolute', right: 20,
                                    zIndex: 1001
                                }}>
                                    <Calendar

                                        className={this.props.hideCalendarFinish ? 'pm-hide-calendar-finish' : ''}
                                        locale={this.props.dictionary.date}
                                        onChange={this.props.dataFinishChange}
                                        value={this.props.dtDataFinish}
                                    />

                                </div> */}
                                {/* </Grid> */}
                                {/* <Grid style={{ marginBottom: 15, textAlign:'right' }} item xs={6} sm={6} md={6} lg={6} xl={6}> */}
                                {/* <span onClick={this.props.showCalendarFinish}  className='insert-task-labels' id='data-sfarsit-task'> <span  style={{    fontSize: 15,
                                                                        fontWeight: 500,
                                                                        color: 'gray'}}>Data Finalizare:</span> <i style={{
                                                                       
                                                                            fontSize: 18,
                                                                            verticalAlign:'middle'
        
                                                                        }}  className='material-icons'>today</i>   */}
                                {/* {this.termenLimita() ? <span style={{ color: 'red' }}><i className='material-icons' style={{
                                                                    color: 'white',
                                                                    backgroundColor: 'red',
                                                                    borderRadius: '50%',
                                                                    padding: 1,
                                                                    fontSize: 14

                                                                }} className='material-icons'>priority_high</i> {this.props.dataFinish}</span> :  */}

                                {/* {this.props.dataFinish}   */}
                                {/* <i onClick={this.props.showCalendarFinish} className='material-icons task-edit'>create</i> */}

                                {/* </span> */}

                                {/* </Grid> */}



                                {/* </Grid> */}

                            </Grid>





                            {/*                                                       

                                                        <select
                                                            className='add-project-input'
                                                            type="text"
                                                            margin="normal"
                                                            value={this.props.objInfoTask.id_utilizator_responsabil}
                                                            onChange={this.props.changeResponsabil}

                                                        >       

                                                            <option value={'0'}>Niciun utilizator selectat</option>
                                                            {this.props.listUsers.map((l, idx) => {
                                                                return (
                                                                    <option key={idx} value={l.id}> 
                                                                    <span>
                                                                    <Avatar
                                                                    className='pm-angajati-picture'
                                                                    style={{ display: 'inline-block', textAlign: 'center', marginLeft: 10, height: 36, width: 36, backgroundColor: new Utils().culoriUtilizatori(this.props.objInfoTask.id) }}>
                                                                    <i style={{ verticalAlign: '-webkit-baseline-middle' }} className='material-icons'>person</i>
                                                                </Avatar>
                                                                <span className='pm-task-change-user'> {l.nume}</span>
                                                                        </span> 
                                                                </option>
                                                                )
                                                            })}

                                                        </select> */}

                            <Grid style={{paddingTop:10}} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container>
                                    <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                        <span id='buget-label' className='insert-task-labels'> <span style={{
                                            fontSize: 15,
                                            fontWeight: 500,
                                            color: 'gray'
                                        }}>{this.props.dictionary.proiecte.budget}:</span>

                                        </span>

                                    </Grid>

                                    {!this.state.showBugetNou &&
                                        <Grid style={{ marginLeft: 30, height: 20 }} item xs={10} sm={10} md={10} lg={10} xl={10}>

                                            <span id='buget-label' className='insert-task-labels'>{this.state.totalBuget} lei
                                                <div
                                                    style={{ marginLeft: 10 }}

                                                    className={this.state.showBuget ? 'buget-label-icons' : 'task-edit'}
                                                // className='buget-label-icons'

                                                >
                                                    <i onClick={() => { this.setState({ showBuget: this.state.showBuget ? false : true, showBugetNou: false }) }}
                                                        style={{ fontSize: 20, verticalAlign: 'sub', marginRight: 10 }}
                                                        className='material-icons '>{this.state.showBuget ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i>

                                                    <i onClick={this.openBugetDetaliat}
                                                        style={{ fontSize: 20, verticalAlign: 'sub' }}
                                                        className='material-icons '> {this.state.showBugetNou ? 'clear' : 'add'}</i>


                                                </div>
                                            </span>
                                        </Grid>
                                    }


                                    <Grid style={{ marginBottom: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        {this.state.showBuget &&
                                            <table style={{ fontSize: 14, width: '100%', borderCollapse: 'collapse', marginTop: 20 }}>
                                                <thead>
                                                    <tr style={{ textAlign: 'left', fontSize: 14 }}>
                                                        <th>{this.props.dictionary.proiecte.budgetName}</th>
                                                        {/* <th>Tva Incl.</th> */}
                                                        {/* <th>TVA%</th>
                                                        <th>Suma</th>
                                                        <th>Val. TVA</th> */}
                                                        <th style={{ textAlign: 'right' }}>{this.props.dictionary.proiecte.budgetValue}</th>
                                                        <th style={{ textAlign: 'right', width: '20%' }}>{this.props.dictionary.proiecte.operations}</th>




                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.listBugetC.map((c, idx) => {

                                                        return (

                                                            <tr key={idx}>
                                                                <td>
                                                                    {/* {c.edit &&
                                                                                        <input
                                                                                            style={{ fontSize: 14, fontWeight: 400 }}
                                                                                            id='titlu-task'
                                                                                            type="text"
                                                                                            className='hidden-input'
                                                                                            margin="normal"
                                                                                            name='nume'
                                                                                            value={c.nume || ''}
                                                                                            onChange={(ev) => { this.changeBuget(ev, c) }}
                                                                                        />
                                                                                    } */}


                                                                    {/* {!c.edit && <span onClick={()=>{this.selectCost(c)}}>{c.nume}</span> } */}
                                                                    <span>{c.nume}</span>

                                                                </td>
                                                                {/* <td>{c.tva || 0}%</td> */}
                                                                {/* <td> */}
                                                                {/* {!c.edit && (c.valoare || 0)} */}


                                                                {/* {c.edit &&
                                                                                        <input
                                                                                            style={{ fontSize: 14, fontWeight: 400, width: '50%'}}
                                                                                            id='titlu-task'
                                                                                            type="number"
                                                                                            className='hidden-input'
                                                                                            margin="normal"
                                                                                            name='valoare'
                                                                                            value={c.valoare || ''}
                                                                                            onChange={(ev) => { this.changeBuget(ev, c) }}
                                                                                        />
                                                                                    } */}
                                                                {/* <span>{c.valoare}</span>
                                                                                     lei


                                                                                    </td>

                                                                <td>
                                                                    {c.valoare * c.tva / 100} lei
                                                                                    </td> */}

                                                                <td style={{ textAlign: 'right' }}>
                                                                    {+(Math.round((c.valoare + (c.valoare * c.tva / 100)) + "e+3") + "e-3")} lei
                                                                </td>








                                                                <td style={{ textAlign: 'right' }}>

                                                                    <input type='file' id={`fileBuget${c.id}`}
                                                                        style={{ display: 'none' }}
                                                                        onChange={() => { this.uploadBugetDoc(`fileBuget${c.id}`, this.props.objInfoTask.id, c) }} />
                                                                    <i style={{ cursor: 'pointer', marginRight: 10 }} onClick={() => { this.addFileCost(`fileBuget${c.id}`) }} className='material-icons pm-standard-icons'>attachment</i>
                                                                    {!this.props.readOnly &&

                                                                        <i style={{ cursor: 'pointer', marginRight: 10 }} onClick={() => { this.selectBuget(c) }} className='material-icons pm-standard-icons'>create</i>
                                                                    }







                                                                    {!this.props.readOnly &&


                                                                        <i style={{ cursor: 'pointer', marginRight: 10 }} onClick={() => { this.deleteBuget(c) }} className='material-icons pm-standard-icons'>delete</i>
                                                                    }




                                                                </td>








                                                            </tr>
                                                        )

                                                    })}


                                                </tbody>
                                                <thead>
                                                    <tr style={{ textAlign: "left" }}>
                                                        <th ></th>

                                                        <th style={{ textAlign: 'right' }}>{this.props.dictionary.proiecte.total}</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody style={{ textAlign: 'left' }}>
                                                    <tr>
                                                        <td ></td>
                                                        {/* <td>{this.state.totalBTVA}</td> */}
                                                        <td style={{ textAlign: 'right' }}>{this.state.totalBuget}</td>
                                                        <td></td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                        }
                                    </Grid>




                                </Grid>
                            </Grid>

                            <Grid style={{ marginBottom: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                                <Grid container>

                                    <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                        <span id='buget-label' className='insert-task-labels'> <span style={{
                                            fontSize: 15,
                                            fontWeight: 500,
                                            color: 'gray'
                                        }}>{this.props.dictionary.proiecte.spendings}:</span>

                                        </span>

                                    </Grid>
                                    <Grid style={{ height: 20, marginLeft: 30 }} item xs={10} sm={10} md={10} lg={10} xl={10}>
                                        <span id='cheltuieli-label' className='insert-task-labels'>  {this.state.totalCost} lei
                                            <div

                                                className={this.state.showCheltuieli ? 'cheltuieli-label-icons' : 'task-edit'}
                                            >
                                                <i onClick={() => { this.setState({ showCheltuieli: this.state.showCheltuieli ? false : true, showCostNou: false }) }}
                                                    style={{ fontSize: 20, verticalAlign: 'sub', marginRight: 10, marginLeft: 10 }}
                                                    className='material-icons '>{this.state.showCheltuieli ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i>

                                                <i onClick={this.openDetaliat}
                                                    style={{ fontSize: 20, verticalAlign: 'sub' }}
                                                    className='material-icons '>add</i>


                                            </div>
                                        </span>

                                    </Grid>

                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        {this.state.showCheltuieli &&
                                            <table style={{ fontSize: 14, width: '100%', borderCollapse: 'collapse', marginTop: 20 }}>
                                                <thead>
                                                    <tr style={{ textAlign: 'left', fontSize: 14 }}>
                                                        <th>{this.props.dictionary.proiecte.spendingName}</th>
                                                        {/* <th>Tva Incl.</th> */}
                                                        {/* <th>TVA%</th>
                                                        <th>Suma</th>
                                                        <th>Val. TVA</th> */}
                                                        <th style={{ textAlign: 'right' }}>{this.props.dictionary.proiecte.spendigValue}</th>
                                                        <th style={{ textAlign: 'right', width: '20%' }}>{this.props.dictionary.proiecte.operations}</th>




                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.listBuget.map((c, idx) => {

                                                        return (

                                                            <tr key={idx}>
                                                                <td>
                                                                    <span >{c.nume}</span>


                                                                </td>
                                                                {/* <td>{c.tva || 0}%</td> */}
                                                                {/* <td>
                                                                    <span>{c.valoare} lei</span>


                                                                </td> */}



                                                                {/* <td>
                                                                    {c.valoare * c.tva / 100} lei
                                                                                    </td> */}
                                                                <td style={{ textAlign: 'right' }}>
                                                                    {+(Math.round((c.valoare + (c.valoare * c.tva / 100)) + "e+3") + "e-3")} lei
                                                                </td>

                                                                <td style={{ textAlign: 'right' }}>
                                                                    <input type='file' id={`fileCost${c.id}`}
                                                                        style={{ display: 'none' }}
                                                                        onChange={() => { this.uploadCostDoc(`fileCost${c.id}`, this.props.objInfoTask.id, c) }} />
                                                                    <i style={{ cursor: 'pointer', marginRight: 10 }} onClick={() => { this.addFileCost(`fileCost${c.id}`) }} className='material-icons pm-standard-icons'>attachment</i>

                                                                    {!this.props.readOnly &&

                                                                        <i style={{ cursor: 'pointer', marginRight: 10 }} onClick={() => { this.selectCost(c) }} className='material-icons pm-standard-icons'>create</i>
                                                                    }


                                                                    {!this.props.readOnly &&

                                                                        <i style={{ cursor: 'pointer' }} onClick={() => { this.deleteCost(c) }} className='material-icons pm-standard-icons'>delete</i>
                                                                    }


                                                                </td>








                                                            </tr>
                                                        )

                                                    })}


                                                </tbody>

                                                <thead>
                                                    <tr style={{ textAlign: "left" }}>
                                                        <th ></th>
                                                        {/* <th>Total TVA</th> */}
                                                        <th style={{ textAlign: 'right' }}>{this.props.dictionary.proiecte.total}</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody style={{ textAlign: 'left' }}>
                                                    <tr>
                                                        <td ></td>
                                                        {/* <td>{this.state.totalBTVA}</td> */}
                                                        <td style={{ textAlign: 'right' }}>{this.state.totalCost}</td>
                                                        <td></td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                        }

                                        {/* {this.state.showCostNou &&
                                                            <Grid style={{width: 'fit-content',
                                                            backgroundColor: 'whitesmoke',
                                                            padding: 10}} container>
                                                                <Grid style={{width:'fit-content'}} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                    <span id='cheltuieli-label' className='insert-task-labels'>Tip Introducere
                                                                        <div

                                                                            className={'cheltuieli-label-icons'}
                                                                        >
                                                                            <i onClick={() => { this.setState({ showCheltuieliTipuri: this.state.showCheltuieliTipuri ? false : true, showCostNouTotal: false, showCheltuieli:false }) }} className='material-icons '>{this.state.showCheltuieliTipuri ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i>
                                                                          

                                                                        </div>
                                                                    </span>
                                                                    {this.state.showCheltuieliTipuri && 
                                                                       <div style={{width:'fit-content'}}>
                                                                       <span onClick={()=>{this.setState({showCheltuieliTipuri:false, showCostNouTotal:true, showCheltuieli:false, showCostNou:false})}}  id='tipuri-cheltuieli1' style={{display:'block',  padding:5}} className='insert-task-labels'>Total
                                                                       
                                                                       </span>
                                                                       <span onClick={this.openDetaliat} id='tipuri-cheltuieli2' style={{display:'block',padding:5}} className='insert-task-labels'>Per Produs(Detaliat)
                                                                       
                                                                       </span>
                                                                       </div>
                                                                    }
                                                                 
                                                                  


                                                                </Grid>
                                                            </Grid>

                                                        } */}

                                        {/* {this.state.showCostNouTotal &&
                                                            <table style={{ fontSize: 14, width: '100%' }}>
                                                                <tbody>
                                                                    <tr >
                                                                        <td>

                                                                            <input
                                                                                style={{ fontSize: 14, fontWeight: 400 }}
                                                                                id='titlu-task'
                                                                                type="text"
                                                                                className='hidden-input'
                                                                                margin="normal"
                                                                                name='nume'
                                                                                value={this.state.costInsert.nume || ''}
                                                                                onChange={this.changeCostInsert}
                                                                            />



                                                                        </td>
                                                                        <td>


                                                                            <input
                                                                                style={{ fontSize: 14, fontWeight: 400, width: '80%' }}
                                                                                id='titlu-task'
                                                                                type="number"
                                                                                className='hidden-input'
                                                                                margin="normal"
                                                                                name='valoare'
                                                                                value={this.state.costInsert.valoare || ''}
                                                                                onChange={this.changeCostInsert}
                                                                            />
                                                                             lei


                                                                        </td>
                                                                        <td style={{    whiteSpace: 'nowrap'}}>{new Utils().dataPrescurtataRomana(new Utils().defaultData())}</td>
                                                                        <td>

                                                                            <i style={{ cursor: 'pointer' }} onClick={this.insertCost} className='material-icons'>check_circle_outline</i>


                                                                        </td>


                                                                    </tr>

                                                                </tbody>
                                                            </table>


                                                        } */}
                                    </Grid>
                                </Grid>






                            </Grid>



                            <Grid style={{ marginBottom: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                                <Grid container>
                                    <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                        <span id='buget-label' className='insert-task-labels'> <span style={{
                                            fontSize: 15,
                                            fontWeight: 500,
                                            color: 'gray'
                                        }}>{this.props.dictionary.proiecte.description}:</span>

                                        </span>

                                    </Grid>
                                    <Grid style={{ marginLeft: 10 }} item xs={10} sm={10} md={10} lg={10} xl={10}>

                                        <textarea
                                            style={{ width: '90%' }}
                                            rows={6}
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='descriere'
                                            value={this.props.taskDescription}
                                            onChange={this.props.taskDescriptionChange}
                                            onBlur={this.props.updateTaskDescription}
                                            placeholder={this.props.dictionary.proiecte.taskDetail}
                                        ></textarea>
                                        {/* <input
                                                                                            style={{ fontSize: 14, fontWeight: 400, width:'90%' }}
                                                                                            id='titlu-task'
                                                                                            type="text"
                                                                                            className='hidden-input'
                                                                                            margin="normal"
                                                                                            name='taskDescription'
                                                                                            value={this.props.taskDescription || ''}
                                                                                            onChange={this.props.taskDescriptionChange}
                                                                                            onBlur={this.props.updateTaskDescription}
                                                                                        /> */}
                                    </Grid>

                                    {this.state.descrieri.map((d, idx) => {
                                        return (
                                            <Grid key={idx} style={{ marginLeft: 82, marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                <Grid container >
                                                    <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                                                        <textarea
                                                            style={{ width: '100%' }}
                                                            rows={6}
                                                            className='add-project-input'
                                                            type="text"
                                                            margin="normal"
                                                            name='descriere'
                                                            value={d.descriere}
                                                            onChange={(ev) => { this.changeDescriere(ev, d) }}
                                                            onBlur={() => { this.updateDescriere(d) }}
                                                            placeholder={this.props.dictionary.proiecte.taskDetail}
                                                        ></textarea>
                                                    </Grid>

                                                    <Grid style={{
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        display: 'flex'
                                                    }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                        <i style={{ cursor: 'pointer' }} onClick={() => { this.deleteDescriere(d) }} className='material-icons pm-standard-icons'>delete</i>
                                                    </Grid>

                                                </Grid>







                                            </Grid>
                                        )
                                    })}



                                    <Grid style={{ marginLeft: 85 }} item xs={11} sm={11} md={11} lg={11} xl={11}>

                                        <span onClick={this.addDescriere} id='cheltuieli-label' className='insert-task-labels'> <span style={{
                                            fontSize: 14,
                                            fontWeight: 400,
                                            color: '#579ae8'
                                        }}>{this.props.dictionary.proiecte.addDescription}
                                            <div

                                                className={this.state.showCheltuieli ? 'cheltuieli-label-icons' : 'task-edit'}
                                            >

                                                <i
                                                    style={{ fontSize: 20, verticalAlign: 'sub', color: 'black', marginLeft: 10 }}
                                                    className='material-icons pm-standard-icons'>add</i>


                                            </div>
                                        </span>
                                        </span>
                                    </Grid>
                                </Grid>




                            </Grid>
                            <Divider style={{ width: '100%' }} />

                            {this.props.explicatieIntarziere &&
                                <Grid style={{ marginBottom: 20, marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>


                                    <Grid container>
                                        <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                            <span id='buget-label' className='insert-task-labels'> <span style={{
                                                fontSize: 15,
                                                fontWeight: 500,
                                                color: 'gray'
                                            }}>{this.props.dictionary.proiecte.delays}:</span>

                                            </span>

                                        </Grid>
                                        <Grid style={{ marginLeft: 10 }} item xs={10} sm={10} md={10} lg={10} xl={10}>

                                            <textarea
                                                style={{ width: '90%' }}
                                                rows={6}
                                                className='add-project-input'
                                                type="text"
                                                margin="normal"
                                                name='descriere'
                                                value={this.props.explicatieIntarziere}
                                                onChange={this.props.explicatieIntarziereChange}
                                                onBlur={this.props.updateExplicatieIntarziere}
                                                placeholder={this.props.dictionary.proiecte.whyDelayedTask}
                                            ></textarea>
                                            {/* <input
                                                                                            style={{ fontSize: 14, fontWeight: 400, width:'90%' }}
                                                                                            id='titlu-task'
                                                                                            type="text"
                                                                                            className='hidden-input'
                                                                                            margin="normal"
                                                                                            name='taskDescription'
                                                                                            value={this.props.taskDescription || ''}
                                                                                            onChange={this.props.taskDescriptionChange}
                                                                                            onBlur={this.props.updateTaskDescription}
                                                                                        /> */}
                                        </Grid>
                                        {/* <span  id='buget-label' className='insert-task-labels'> <span style={{    fontSize: 15,
                                                                                        fontWeight: 500,
                                                    color: 'gray'}}>Intarzieri: <span style={{color:'rgb(243, 105, 105)'}}>{this.props.explicatieIntarziere}</span> </span> 

                                                                                </span> */}
                                    </Grid>
                                </Grid>
                            }



                            <Grid style={{ marginBottom: 20, marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                                <div id='list-atasamente' style={{ display: 'flex', }}>

                                    <div style={{ marginLeft: 10 }}>
                                        <input type='file' id={`fileTask`}
                                            style={{ display: 'none' }}
                                            onChange={() => { this.uploadTaskDoc(`fileTask`, this.props.objInfoTask.id) }} />


                                        <div style={{ display: 'inline-block', marginBottom: 10 }} id='atasament-nou' onClick={() => { this.selectTaskFile('fileTask') }}>
                                            <span id='cheltuieli-label' className='insert-task-labels'> <span style={{
                                                fontSize: 14,
                                                fontWeight: 400,
                                                color: '#579ae8'
                                            }}>{this.props.dictionary.proiecte.addAttachment}
                                                <div

                                                    style={{ display: "inline-block" }}
                                                >

                                                    <i
                                                        style={{ fontSize: 20, verticalAlign: 'sub', color: 'black', marginLeft: 10 }}
                                                        className='material-icons pm-standard-icons'>attachment</i>


                                                </div>
                                            </span>
                                            </span>

                                        </div>
                                        {this.props.listDocumente.map((d, idx) => {
                                            // console.log('d :>> ', d);

                                            return (
                                                <Chip
                                                    key={idx}
                                                    label={<span style={{ color: 'black' }} onClick={() => { this.goToFile(d) }}> <i style={{ verticalAlign: 'middle', fontSize: 18, marginRight: 5 }} className='material-icons'>description</i>{d.nume}</span>}
                                                    onDelete={() => { this.deleteDoc(d) }} color="primary"
                                                    style={{ backgroundColor: '#f1f1f1', marginLeft: 20, marginBottom: 10 }}
                                                    deleteIcon={<i className='material-icons pm-chip-delete-icon' style={{fontSize:21}}>clear</i>}
                                                />
                                                // <div key={idx}><span className='insert-task-labels'>
                                                //     <span onClick={() => { this.goToFile(d) }}>{d.nume}</span> <i style={{ verticalAlign: 'middle', fontSize: 20 }} className='material-icons'
                                                //      onClick={() => { this.deleteDoc(d) }}>delete</i></span></div>
                                            )
                                        })}





                                    </div>

                                </div>



                            </Grid>
                            <Grid style={{ marginBottom: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                                <Button style={{ display: 'inline-block', padding: '10px 20px 10px 20px', backgroundColor: '#07B14B', color: 'white', fontWeight: 500, textTransform: 'none'}} onClick={this.props.dialogClose}  >

                                    {this.props.dictionary.proiecte.save}
                                </Button>


                                {!this.props.readOnly &&
                                    <Button style={{ display: 'inline-block', padding: '10px 20px 10px 20px', backgroundColor: '#FF5858', color: 'white', fontWeight: 500, marginLeft: 20, textTransform: 'none'}} onClick={this.props.openDeleteTask}  >

                                        {this.props.dictionary.proiecte.delete}
                                    </Button>
                                }




                            </Grid>


                        </Grid>






                    </DialogContent>



                    {/* {this.filterSubTaskuri()} */}




                </Dialog>

                <BugetEtapaTask
                    open={this.state.isOpenBuget}
                    cheltuialaSelectata={this.state.cheltuialaSelectata}
                    changeNumeCheltuiala={this.changeNumeCheltuiala}
                    tipCost={this.state.cheltuialaSelectata.tip}
                    tipuriCost={[{ id: 'cost_direct', nume: 'Direct' }, { id: 'cost_personal', nume: 'Cheltuiala cu personal' }]}
                    changeTip={this.changeTip}
                    numeCost={this.state.cheltuialaSelectata.nume}
                    subCosturi={this.state.subCosturi}
                    getSubCosturi={this.selectCost}
                    objInfoTask={this.props.objInfoTask}
                    proiectInfo={this.props.proiectInfo}
                    getTaskData={()=>{this.setState({isOpenBuget: true}, ()=>{
                        this.props.getTaskData()
                    }) }}
                    insertOrUpdateCost={this.insertOrUpdateCost}
                    updateCost={this.updateValoareTotalaCost}
                    scop={'task'}
                    changeObj={this.changeCostObj}
                    idEtapa={this.props.objInfoTask.id}
                    title={'Buget Task ' + this.props.taskTitle}
                    dialogClose={() => { this.setState({ isOpenBuget: false }) }}
                    costuriEtapa={this.state.listBuget}
                    numeChange={this.numeConstChange}
                    updateNume={this.updateNume}
                    valoareChange={this.valoareCostChange}
                    updateValoare={this.updateValoareCost}
                    dataChange={this.dataCostChange}
                    updateData={this.updateDataCost}
                    getData={this.openBugetEtapa}
                    tipIntroducere={this.state.tipIntroducere}
                    changeTipIntroducere={(ev) => { this.setState({ tipIntroducere: ev.target.value }) }}
                    tipuriIntroducere={this.state.tipuriIntroducere}
                    bugete={this.state.listBugetC}
                    docSubcosturi={this.state.docSubcosturi}
                    listDocumente={this.props.listDocumente}
                    selectCost={this.selectCost}
                    listUsers={this.props.listUsers}

                />


                {this.state.isOpenBugetB &&

                    <BugetEtapaTaskB
                        open={this.state.isOpenBugetB}
                        cheltuialaSelectata={this.state.bugetSelectat}
                        changeNumeCheltuiala={this.changeNumeBuget}
                        tipCost={this.state.bugetSelectat.tip}
                        tipuriCost={[{ id: 'cost_direct', nume: 'Direct' }, { id: 'cost_personal', nume: 'Buget cu personal' }]}
                        changeTip={this.changeTipBuget}
                        numeCost={this.state.bugetSelectat.nume}
                        subCosturi={this.state.subCosturi}
                        getSubCosturi={this.selectBuget}
                        objInfoTask={this.props.objInfoTask}
                        proiectInfo={this.props.proiectInfo}
                        getTaskData={this.props.getTaskData}
                        insertOrUpdateCost={this.insertUpdateBuget}
                        updateCost={this.updateValoareTotalaBuget}
                        scop={'task'}
                        changeObj={this.changeCostObj}
                        idEtapa={this.props.objInfoTask.id}
                        title={'Buget Task ' + this.props.taskTitle}
                        dialogClose={() => { this.setState({ isOpenBugetB: false }) }}
                        costuriEtapa={this.state.listBuget}
                        numeChange={this.numeBugetChange}
                        updateNume={this.updateNumeBuget}
                        valoareChange={this.valoareBugetchange}
                        updateValoare={this.updateValoareBuget}
                        dataChange={this.dataBugetChange}
                        updateData={this.updateDataBuget}
                        getData={this.openBugetEtapa}
                        tipIntroducere={this.state.tipIntroducere}
                        changeTipIntroducere={(ev) => { this.setState({ tipIntroducere: ev.target.value }) }}
                        tipuriIntroducere={this.state.tipuriIntroducereB}
                        bugete={this.state.listBugetC}
                        docSubcosturi={this.state.docSubcosturi}
                        listDocumente={this.props.listDocumente}
                        selectCost={this.selectBuget}
                        listUsers={this.props.listUsers}

                    />
                }


            </div>
        );
    }
}

InsertUpdateTask.propTypes = {
    open: PropTypes.bool,
    dialogClose: PropTypes.func,
    taskCompletat: PropTypes.string,
    taskFinalizat: PropTypes.func,
    dictionary: PropTypes.object,
    dataStart: PropTypes.string,
    dataFinish: PropTypes.string,
    dtDataStart: PropTypes.any,
    dataStartOpen: PropTypes.func,
    dataFinishOpen: PropTypes.func,

    dtDataFinish: PropTypes.any,
    hideCalendarFinish: PropTypes.bool,
    hideCalendar: PropTypes.bool,
    showCalendarStart: PropTypes.func,
    showCalendarFinish: PropTypes.func,
    hideCal: PropTypes.func,
    dataStartChange: PropTypes.func,
    dataFinishChange: PropTypes.func,
    taskTitle: PropTypes.string,
    taskTitleChange: PropTypes.func,
    updateTaskTitle: PropTypes.func,
    listEtape: PropTypes.array,
    listTaskuri: PropTypes.array,
    getData: PropTypes.func,
    isOpenMenuEtape: PropTypes.bool,
    closeMenuEtape: PropTypes.func,
    etapaTitle: PropTypes.string,
    etapeClick: PropTypes.func,
    objInfoTask: PropTypes.object,
    listUsers: PropTypes.array,
    isUtlizatorOpen: PropTypes.bool,
    closeUtilizator: PropTypes.func,
    userClick: PropTypes.func,
    listSubTaskuri: PropTypes.array,
    candOra: PropTypes.string,
    candOraChange: PropTypes.func,
    panaCandOra: PropTypes.string,
    panaCandOraChange: PropTypes.func,
    updateTaskCandOra: PropTypes.func,
    updateTaskPanaCandOra: PropTypes.func,
    taskDescription: PropTypes.string,
    taskDescriptionChange: PropTypes.func,
    updateTaskDescription: PropTypes.func,
    deleteTask: PropTypes.func,
    colorChange: PropTypes.func,
    culoriTaskuri: PropTypes.array,
    userView: PropTypes.bool,
    openListTimpEstimatLucru: PropTypes.func,
    openListDocumente: PropTypes.func,


}
